import PlanDialog from './src/PlanDialog.vue';
import PlanDialogModal from './src/PlanDialogModal.vue';
import type { PricingPlan } from './src/PlanDialog.vue';
import { createApp, type App } from 'vue';
import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import { cn, en, jp, tw } from './src/locales';
import { usePlg } from '../edition-upgrade';

export { PlanDialog, PlanDialogModal, type PricingPlan };

const i18n = createI18n({
    legacy: false,
    locale: getCurrentLanguage(),
    fallbackLocale: 'en',
    messages: {
        cn,
        en,
        jp,
        tw,
    },
});

let isPricingUpgradeDialogOpen = false;

export const openPricingUpgradeDialog = async(params?: {eventDetail?: Record<string, any>}) => {
    if (isPricingUpgradeDialogOpen) { return }
    isPricingUpgradeDialogOpen = true;
    const { checkIsLsPlg } = usePlg()
    if (!await checkIsLsPlg()) { return }

    const div = document.createElement('div');
    div.setAttribute('data-theme', 'patsnapRD');
    document.body.appendChild(div);

    const unmountApp = (app: App) => {
        app.unmount();
        document.body.removeChild(div);
    };

    const promise = new Promise<boolean | undefined>((resolve) => {
        const app = createApp(PlanDialogModal, {
            eventDetail: params?.eventDetail,
            callback: () => {
                resolve(true);
                unmountApp(app);
                isPricingUpgradeDialogOpen = false;
            },
        });
        app.use(i18n);
        app.mount(div);
    });

    return promise;
}
